import React from 'react';
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import IconButton from "../../buttons/icon-button/IconButton";
import SomlService from "../../../services/soml-service";
import Notification from "../../../common/Notification";
import * as FileSaver from "file-saver";

type DownloadSchemaActionProps = {
  schemaId: string,
  standardButton?: boolean
  disabled?: boolean
};

/**
 * Generic action for triggering a download of given SOML schema.
 *
 * @param {DownloadSchemaActionProps} props
 * @returns {any}
 * @constructor
 */
export default class DownloadSchemaAction extends React.Component<DownloadSchemaActionProps> {

  constructor(props: DownloadSchemaActionProps) {
    super(props);
    this.download = this.download.bind(this);
  }

  private download() {
    return SomlService.downloadSchema(this.props.schemaId).then((data) => {
      FileSaver.saveAs(data, `${this.props.schemaId}.yaml`);
    }).catch((error) => {
      const reason = error ? ` Reason: ${error.toString()}` : "";
      const message = `Can't download schema.${reason}`;
      Notification.error({message});
    });
  }

  render() {
    const classes = classNames("DownloadSchemaAction", {
      "btn btn-primary": this.props.standardButton
    });
    return (
      <>
        {
          this.props.standardButton && <Button className={classes}
                                               disabled={this.props.disabled}
                                               onClick={this.download}
                                               title="Download schema">
            Download
          </Button>
        }
        {
          !this.props.standardButton && <IconButton icon="download"
                                                    onClick={this.download}
                                                    disabled={this.props.disabled}
                                                    title="Download schema"
                                                    className={classes}/>
        }
      </>
    );
  }

}
